import { Component, Input, OnInit, inject } from '@angular/core';
import { ScorecardDisplayType, ScorecardFacade, ScorecardV2, ScorecardV2Query } from '@fgb/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-scorecards-v2-featured',
  templateUrl: './scorecards-v2-featured.component.html',
  styleUrl: './scorecards-v2-featured.component.scss',
})
export class ScorecardsV2FeaturedComponent implements OnInit {
  private scorecardFacade = inject(ScorecardFacade);
  private scorecardQuery = inject(ScorecardV2Query);

  /** Route of the challenges page that the view all link opens */
  @Input() viewAllLink = '/challenges';

  scorecards$: Observable<ScorecardV2[]>;

  carouselOptions: OwlOptions = {
    loop: false,
    dots: true,
    nav: false,
    margin: 16,
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
    },
  };

  ngOnInit(): void {
    this.scorecardFacade.fetchScorecards();
    this.scorecards$ = this.scorecardQuery.selectScorecards({
      filterBy: (s: ScorecardV2) =>
        s.Favourite && !s.Completed && !s.Locked && s.ScoreCardDisplayType !== ScorecardDisplayType.streakView,
    });
  }
}
